import XLSX from "xlsx";
import moment from "moment";

import fetch from "@/assets/js/axios.js";
import { getValue } from "@/assets/js/public.js";
import store from "../../store";

const pageLimit = 10000
let time = ''

export const exportExcel = function (data, title, excelCount = 0) {
  let worksheet = XLSX.utils.aoa_to_sheet(data)
  let workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, title)
  XLSX.writeFile(workbook, `${title}_${time}${excelCount ? `(${excelCount})` : ''}.xlsx`)
}

async function fetchData (url, searchValue, column, page, limit, method = 'POST', total_key, summary) {
  let result = []
  const data = {
    ...searchValue,
    page,
  }
  data[limit] = pageLimit
  const fetchParams = {
    url,
    method,
  }
  fetchParams[method === 'POST' ? 'data' : 'params'] = data
  await fetch(fetchParams).then(res => {
    const { status, data } = res.data
    if (status && data) {
      let list = []
      if (data.data) {
        list = summary ? data.data.list : data.data
      } else if (data.list) {
        list = data.list
      }
      list.forEach(item => {
        let arr = []
        column.forEach(item2 => {
          let value = getValue(item, item2.prop)
          if (item2.formatter) value = item2.formatter(null, null, value)
          arr.push(value)
        })
        result.push(arr)
      })
    }
  }).catch(err => {
    console.log(err);
    store.commit('setExportDownloadPercent', null)
  })
  return result
}

export const exportData = async function ({url, name, column, limit = 'limit', method = 'POST'}, {totalRecords, searchValue, total_key, summary = false}) {
  const count = Number((totalRecords / pageLimit).toFixed()) + 1
  let exportData = [column.map(item => item.label)]
  let excelCount = 1
  time = moment(new Date()).format("YYYY-MM-DD_HH时mm分ss秒")
  for (let i = 0; i < count; i++) {
    const page = i + 1
    store.commit('setExportDownloadPercent', (page/count*100).toFixed(2))
    const result = await fetchData(url, searchValue, column, page, limit, method, total_key, summary)
    if (result) {
      exportData = exportData.concat(result)
      if ((page%10) === 0) {
        exportExcel(exportData, name, excelCount)
        excelCount += 1
        exportData = [column.map(item => item.label)]
        if (page === count) store.commit('setExportDownloadPercent', null)
      } else if (page === count) {
        exportExcel(exportData, name, excelCount)
        store.commit('setExportDownloadPercent', null)
      }
    }
  }
}
